export default __webpack_public_path__ + "logo.1acd6cf7e6b7a7df905b50fc03fbc5ec.png";